import React, { useEffect, useState } from 'react';
import RelatedPersons from '../../ui/RelatedPersons/RelatedPersons';
import ExpandedCard from '../../../../components/ExpandedCard/ExpandedCard';
import { Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import { ReactComponent as RelatedFilterCard } from '../../../../../../resource/RelatedFilterCard.svg';

const RelatedPersonsCard = () => {
  const [expanded, setExpanded] = useState(false);

  const handleExpanded = () => setExpanded((prev) => !prev);

  const { companyId } = useSelector((state) => state.documentFilterNewStore);

  useEffect(() => {
    if (companyId) {
      setExpanded(true);
      return;
    }

    setExpanded(false);
  }, [companyId]);

  return (
    <Tooltip title={!companyId && 'Укажите УК, чтобы открыть фильтры'}>
      <div>
        <ExpandedCard
          expanded={expanded}
          handleExpanded={handleExpanded}
          heading="Связанные лица"
          disabled={!companyId}
          icon={<RelatedFilterCard />}
        >
          <RelatedPersons />
        </ExpandedCard>
      </div>
    </Tooltip>
  );
};

export default RelatedPersonsCard;
